(function ($, Cobalt, undefined) {
	Cobalt.Gallery = {
		areaSelected: function (img, selection, imageViewer) { },
		createTag: function (tagId, tagName, tagUrl) { },
		fullImageID: 0,
		initialize: function () {

			/* Handle Add content button */
			$(".module.gallery .user-action-add-category-content a").click(function () {
				try {
					var url = $(this).attr('href');
					$.get(url, function (data) {
						var $editDiv = $('<div>');
						$editDiv.html(data);

						$editDiv.dialog({
							modal: true,
							dialogClass: "modal",
							draggable: false,
							title: "Add Content",
							resizable: false,
							close: function (event, ui) {
								$(event.target).hide();
							}
						});

						$editDiv.parent().center({ sizeToWindow: true, maxWidth: 400, maxHeight: 300 });
						Cobalt.triggerHtmlInsert($editDiv);
					});
				} catch (e) { }

				return false;
			});

			var galleryItem = $("#gallery-item");
			if (galleryItem.length > 0) {
				var imageViewer = $(".guild-galleries .image-viewer");
				if (imageViewer.length > 0) {
					Cobalt.Gallery.setFullImageID(parseInt(imageViewer.attr("data-id")));
					Cobalt.Gallery.displayImagesSeen();

					Cobalt.Gallery.setupTagger(imageViewer);
				}
			}

			Cobalt.Gallery.displayImagesSeen();
		},
		setupTagger: function (imageViewer) {
			imageViewer = imageViewer === undefined ? $(".guild-galleries .image-viewer") : imageViewer;
			var initialTags = new Array();
			$(".guild-galleries").find(".tagged-list li[data-tag-id]").each(function () {
				var li = $(this);
				if (li.find("a").length <= 0) {
					li.html($("<a>").attr("href", "#").html(li.html()));
				}
				var tagObj = $.parseJSON($(this).attr("data-tag-json"));
				initialTags.push(tagObj);
			});

			var isEnabled = imageViewer.attr("data-allow-tagging") === "True";

			$(".guild-galleries").delegate(".guild-galleries .image-viewer, .guild-galleries .tagged-list, .guild-galleries .tag-button", "mouseover", function () {
				if (imageViewer.tagger === undefined) {
					imageViewer.tagger = new Cobalt.GalleryImageTagger({
						imageViewer: imageViewer,
						initialTags: initialTags,
						tagList: ".guild-galleries .tagged-list",
						isEnabled: isEnabled
					});
				}
			});
			imageViewer.find("a").click(function (e) {
				e.preventDefault();
				Cobalt.Gallery.handleImageLinkClick($(this));
			});
		},
		displayImagesSeen: function () {
			var imagesSeen = Cobalt.Gallery.ImagesSeen;
			if (!(imagesSeen instanceof Object)) {
				imagesSeen = {};
			}

			// latest images
			$(".latest-gallery-image[data-image-id]").each(function (i, val) {
				var image = $(val).find("img");
				var imageID = parseInt($(val).attr("data-image-id"));
				var galleryID = $(val).attr("data-gallery-id");
				var galleryImageIDs = imagesSeen[galleryID];
				if (galleryImageIDs) {
					if (galleryImageIDs.indexOf(imageID) < 0) {
						var imageAdded = $("<span>").addClass("images-added").html(Cobalt.Localization.Main.Global.Common.New());
						image.parents("a").append(imageAdded);
					}
				}
			});

			// galleries
			var galleries = $(".gallery-has-images");
			galleries.each(function (i, val) {
				var gallery = $(val);
				var id = parseInt(gallery.attr("data-id"));
				if (id) {
					var galleryImageIDs = imagesSeen[id];
					var imageIDs = $.parseJSON(gallery.attr("data-image-ids"));
					var count = 0;
					if (galleryImageIDs) {
						$(imageIDs).each(function (i, val) {
							var imageID = imageIDs[i];
							if (galleryImageIDs.indexOf(imageID) < 0) {
								count++;
							}
						});

					} else {
						count = imageIDs.length;
					}
					if (count > 0) {
						gallery.append($("<span>").addClass("images-added").html(count + " " + Cobalt.Localization.Main.Global.Common.New()));
					}
				}
			});
		},
		setFullImageID: function (fullImageID) {
			Cobalt.Gallery.fullImageID = fullImageID;
			if (Cobalt.Gallery.fullImageID > 0) {
				$.post(Cobalt.Routes.Instance.GallerySetImageSeen(Cobalt.Gallery.fullImageID),
                    function () {

                    });
			}
		},
		handleImageLinkClick: function ($link) {
			$link.addClass('modal-loading');
			var href = $link.attr('href');
			var title = $link.attr('data-title');

			var maxWidth = parseInt($link.attr('data-max-width'));
			var minWidth = parseInt($link.attr('data-min-width'));
			var maxHeight = parseInt($link.attr('data-max-height'));
			var autoHeight = $link.attr('data-auto-height') == "true";

			$.get(href, function (data) {
				var $html = $(data);
				$html.dialog(
                {
                	draggable: false,
                	title: title,
                	modal: true,
                	resizable: false,
                	dialogClass: 'modal',
                	open: function () {
                		var imageViewer = $(".gallery-item-modal .image-viewer");
                		if (imageViewer.length > 0) {
                			var initialTags = new Array();
                			$(".gallery-item-modal").find(".tagged-list li[data-tag-id]").each(function () {
                				var li = $(this);
                				if (li.find("a").length <= 0) {
                					li.html($("<a>").attr("href", "#").html(li.html()));
                				}
                				var tagObj = $.parseJSON($(this).attr("data-tag-json"));
                				initialTags.push(tagObj);
                			});
                			var isEnabled = true;
                			$(".gallery-item-modal").delegate(".gallery-item-modal .image-viewer, .gallery-item-modal .tagged-list", "mouseover", function () {
                				if (imageViewer.tagger === undefined) {
                					imageViewer.tagger = new Cobalt.GalleryImageTagger({
                						imageViewer: imageViewer,
                						initialTags: initialTags,
                						tagList: ".gallery-item-modal .tagged-list",
                						isEnabled: isEnabled
                					});
                				}
                			});
                		}
                	},
                	close: function (event, ui) {
                		$html.dialog("destroy");
                		$html.remove();
                	}
                });
				var container = $html.dialog("widget");
				Cobalt.triggerHtmlInsert($html.parent());
				container.center({ sizeToWindow: true, minWidth: minWidth, maxWidth: maxWidth, maxHeight: maxHeight, autoHeight: autoHeight });
				$link.removeClass('modal-loading');
			});
		}
	};

	Cobalt.GalleryImageTagger = function (settings) {
		this.bind(settings);
	};

	Cobalt.GalleryImageTagger.prototype = {
		bind: function (settings) {
			this.areaSelected = function (img, selection, imageViewer) { Cobalt.Gallery.areaSelected(img, selection, imageViewer); };
			this.createTag = function (tagId, tagName, tagUrl) {
				var tag = Cobalt.Gallery.createTag(tagId, tagName, tagUrl);
				return tag;
			};
			this.tagger = settings.tagger;
			this.imageViewer = settings.imageViewer;
			this.initialTags = settings.initialTags;
			this.isEnabled = settings.isEnabled;
			this.tagList = settings.tagList;
			this.imageParent = settings.imageParent;
			this.setupImageTagging();
		},
		setupImageTagging: function () {
			var that = this;
			that.tagger = new Cobalt.ImageTagging({
				enableEditing: this.isEnabled,
				imageSelector: ".taggable-image",
				imageParent: that.imageParent !== undefined ? that.imageParent : that.imageViewer.selector,
				initializeTaggingButton: ".tag-button",
				tagList: that.tagList,
				availableTags: {},
				initialTags: this.initialTags !== undefined ? this.initialTags : {},
				autoStartTagging: false,
				onAreaSelected: this.onAreaSelected,
				onSelectChange: function (img, selection) {
					selection.x1 /= img.width;
					selection.x2 /= img.width;
					selection.y1 /= img.height;
					selection.y2 /= img.height;
					selection.height /= img.height;
					selection.width /= img.width;
					$("#field-position-x").val(selection.x1);
					$("#field-position-y").val(selection.y1);
					$("#field-width").val(selection.width);
					$("#field-height").val(selection.height);
				},
				createTag: this.createTag,
				createDeleteLink: function (rect, img, imageParent, tagLink) {
					var tagID = tagLink.attr("data-tag-id");
					var tag = $(that.tagList).find("[data-tag-id='" + tagID + "']");
					if (tag.length > 0) {
						var enableDelete = tag.attr("data-enable-deletion");
						if (enableDelete === "true") {
							var borderLeftOffset = parseInt(tagLink.css("border-left-width").replace("px", "") || "0");
							var borderTopOffset = parseInt(tagLink.css("border-top-width").replace("px", "") || "0");
							var leftOffset = ((imageParent.width() - img.width()) / 2) - borderLeftOffset;
							var topOffset = ((imageParent.height() - img.height()) / 2) - borderTopOffset;
							var top = (rect.y1 * img.height()) + topOffset;
							var left = (rect.x1 * img.width()) + leftOffset;
							var closeLink = $("<a>").addClass("close").attr("href", Cobalt.Routes.Instance.GalleryRemoveTag(tagID)).html("[x]");
							closeLink.click(function (e) {
								e.stopImmediatePropagation();
								e.preventDefault();
								if (!confirm("Delete?")) {
									return;
								}
								var galleryItem = $("#gallery-item");
								galleryItem.mask();
								$.post($(this).attr("href"), function () {
									document.location.reload();
								});
							});
							closeLink.css("top", top + 5).css("left", tagLink.width() + left - 10);
							return closeLink;
						}
					}
					return "";
				}
			});
			$(".tag-button").click(function (e) {
				if (that.tagger.taggingStarted) {
					$(this).html("<span>Stop Tagging</span>");
				} else {
					var galleryItem = $("#gallery-item");
					galleryItem.mask();
					$.get(Cobalt.Routes.Instance.GalleryReloadImage(galleryItem.attr("data-id")), function (result) {
						galleryItem.empty().html($(result));
						galleryItem.unmask();
						Cobalt.Gallery.setupTagger();
						Cobalt.triggerHtmlInsert($(that.tagger.imageParent).parent());
					});
				}

				e.stopImmediatePropagation();
			});
		},
		onAreaSelected: function (img, selection) {
			var taggingForm = $("#tagging-form");
			if (taggingForm.html() === "") {
				var that = this;
				var imageViewer = $(that.imageParent);
				var selectedValue = selection.Value;
				$.ajax({
					url: Cobalt.Routes.Instance.GalleryAddTag(imageViewer.attr("data-id")),
					cache: false,
					success: function (results) {
						taggingForm.empty().show().addClass("modal").html(results);

						var selection = $(".imgareaselect-selection")
						selection.css("font-size", "inherit").append(taggingForm).parent().css("overflow", "visible");
						$("#field-position-x").val(selectedValue.x1);
						$("#field-position-y").val(selectedValue.y1);
						$("#field-width").val(selectedValue.width);
						$("#field-height").val(selectedValue.height);

						// Ajax submission
						var tagForm = taggingForm.find(".tag-form");
						tagForm.unbind("submit");
						tagForm.ajaxForm({
							beforeSubmit: function () {
								tagForm.find(':submit').attr('disabled', 'disabled');
							},
							success: function (result) {
								if (result !== null && result !== undefined && result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
									result = $.parseJSON(result);
									taggingForm.empty().hide();
									var newTagJSON = "{\"id\":" + result.ID + ",\"name\":\"" + result.Text
                                            + "\",\"rect\":{"
                                            + "\"x1\":" + result.PositionX + ","
                                            + "\"y1\":" + result.PositionY + ","
                                            + "\"width\":" + result.Width + ","
                                            + "\"height\":" + result.Height + "}}";
									var newTagText = result.Text;

									if ($(result.Text).find("a").length < 1) {
										newTagText = $("<a>").attr("href", "#").html(result.Text);
									}
									var newTag = $("<li>").attr("data-tag-id", result.ID).attr("data-enable-deletion", "true").html(newTagText);
									$(that.tagList).find("li").last().append(", ");
									$(that.tagList).append(newTag);

									that.createTaggedRegion(result.ID, result.Text,
                                        {
                                        	x1: result.PositionX,
                                        	y1: result.PositionY,
                                        	width: result.Width,
                                        	height: result.Height
                                        });
									$("#tagging-form a.close").click();

									$(".ac_results").hide();
									$(".ac_results").remove();
									Cobalt.triggerHtmlInsert(taggingForm);
								} else {
									taggingForm.find(":submit").removeAttr("disabled");
									Cobalt.Forms.displayErrors(tagForm, result.Errors);
								}
							},
							error: function () {
								$.log("error");
							}
						});

						var taggingField = $("#tagging-form .tag-field");
						var taggingCloseLink = $("#tagging-form a.close");
						taggingField.focus();
						taggingForm.mousedown(function (e) {
							if ($(e.target) != taggingCloseLink) {
								e.stopImmediatePropagation();
							}
						});
						taggingCloseLink.click(function (e) {
							e.preventDefault();
							$("#tagging-form").removeClass("modal").hide();
							$("#tagging-form").empty();
							that.imgAreaSelect.cancelSelection();
							e.stopImmediatePropagation();
						});
						Cobalt.Gallery.areaSelected(img, selection, Cobalt.Gallery.imageViewer);
					}
				});
			}
		}
	};

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Gallery.js